<template>
  <div class="view availability">
    <h1>{{ $t('availability.label') }}: {{ category.name }}</h1>

    <div class="calendar-item-container">
      <availability-calendar :category="categoryId" :value="activeDate" @input="updateActiveDate" :unavailabilities="this.day.monthUnavailability"  @changedMonth="changedMonth"/>

      <div class="item-list-container">
        <div class="list-title">{{ selectedDateLabel }} - {{ day.count }} {{ $tc('general.label.activity', day.count, {count: day.count}) }}</div>

        <ul class="item-list">
          <li v-for="item in dayItems" :key="item.id">
            <router-link :to="{ name: item.routeName, params: {id: item.id} }" class="item" :class="{inactive: item.inventoryStatus !== 1 && item.inventoryStatus !== 2 }">
              <div class="time">{{ (item.activityType != 'ticket' && item.activityType != 'rental') ? formatTime(item.inventoryTime) : '' }}</div>
              <div>
                {{ item.name }}
                <status-badge :status="item.inventoryStatus" :inventory="item.inventory"></status-badge>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import AvailabilityCalendar from '@/components/AvailabilityCalendar.vue';
import AvailabilityDay from '@/models/AvailabilityDay';
import Category from '@/models/Category';
import Activity from '@/models/Activity';
import moment from 'moment';
import constants from '@/include/constants';
import StatusBadge from '@/components/StatusBadge';

export default {
  props: {
    categoryId: Number,
  },

  data() {
    return {
      type: 'activity',
      breadcrumbLabel: this.$t('availability.label'),
      constants
    }
  },

  created() {
    this.updateItems();
    Category.fetch('activity', this.categoryId);
  },

  computed: {

    // for breadcrumbs
    category() {
      return Category.find(this.categoryId) || new Category();
    },

    activeDate() {
      return this.$store.state.activeDate;
    },

    selectedDateLabel() {
      return moment(this.activeDate).format('MMM D, YYYY');
    },

    day() {
      return AvailabilityDay.find(`${this.categoryId}-${moment(this.activeDate).format('YYYY-MM-DD')}`) || new AvailabilityDay();
    },

    dayItems() {
      return (this.day.items || []).sort((a, b) => a.inventoryTime.localeCompare(b.inventoryTime)).map(item => new Activity(item));
    }
  },

  methods: {
    changedMonth(date){
      let id = moment(this.activeDate).format('YYYY-MM-DD');
      if (date.getMonth() != this.activeDate.getMonth()) {
        AvailabilityDay.fetchDay(id, this.categoryId, date);
      } else {
        AvailabilityDay.fetchDay(id, this.categoryId);
      }
    },

    updateActiveDate(val) {
      this.$store.dispatch('setActiveDate', val);
      this.updateItems();
    },

    formatTime(t) {
      let hm = t.split(':');
      hm.pop();
      return hm.join(':');
    },

    updateItems() {
      let id = moment(this.activeDate).format('YYYY-MM-DD');
      AvailabilityDay.fetchDay(id, this.categoryId);
    }
  },

  components: {
    AvailabilityCalendar,
    StatusBadge
  }
}
</script>

<style lang="scss">
.view.availability {

  .calendar-item-container {
    @include breakpoint(medium) {
      display: grid;
      display: -ms-grid;
      grid-template-columns: 310px 1fr;
      -ms-grid-columns: 310px 1fr;
      grid-gap: 25px;
      padding-top: 15px;
    }
  }


  // Calendar style override
  .component.availability-calendar {
    margin-bottom: 0;
    -ms-grid-column: 1;

    .vdp-datepicker__calendar {
      @include breakpoint(medium) {
        border: none;
      }

      header {
        @include breakpoint(medium) {
          line-height: 40px;
        }
      }

      .cell {
        @include breakpoint(medium) {
          height: 43px;
          line-height: 43px;
        }
      }
    }
  }


  .item-list-container {
    @include breakpoint(medium) {
      box-shadow: 0 1px 4px rgba(0,0,0,.3);
      padding: 20px 30px 30px 30px;
      -ms-grid-column: 2;
    }
    /*  IE */
    @media all and (-ms-high-contrast:none) {
      border: 1px solid $colorPaleGray;
      margin-left: 20px;
    }
  }

  .list-title {
    color: $colorGray;
    margin: 10px 0;
    @include breakpoint(medium) {
      @include font-h2;
      color: $colorDefault;
    }
  }

  .item-list {
    @include unlisted;

    > li {
      border-top: 1px solid $colorPaleGray;
      margin-left: -15px;
      padding: 0 15px;
      width: calc(100% + 30px);
      @include breakpoint(medium) {
        margin-left: unset;
        padding: 0;
        width: unset;
      }

      &:last-child {
        border-bottom: 1px solid $colorPaleGray;
      }
    }

    .item {
      display: grid;
      display: -ms-grid;
      grid-template-columns: 50px 1fr;
      -ms-grid-columns: 50px 1fr;
      padding-top: 10px;
      padding-bottom: 10px;

      .time {
        font-weight: 600;
        -ms-grid-column: 1;
      }
      > div:last-of-type {
        -ms-grid-column: 2;
      }

      &.inactive {
        color: $colorGray;
      }
    }

    .nearing-capacity {
      @include badge($colorYellow);
    }

    .sold-out, .unavailable {
      @include badge($colorGray);
    }

    .available {
      @include badge($colorGreen);
    }

    .nearing-capacity, .sold-out,
    .unavailable, .available {
      @include font-smaller;
      margin-left: 4px;
    }
  }
}
</style>